<script setup lang="ts">
import { LAWYER_INFO } from '@/pages/lawyer/model/keys';

const isMobile: boolean = useIsMobile();
const lawyerInfo = inject(LAWYER_INFO);

const educations = computed(() => lawyerInfo?.value?.educations ?? []);

const getPeriod = (start?: string, end?: string): string => {
  const startYear = start ? new Date(start).getFullYear() : '';
  const endYear = end ? new Date(end).getFullYear() : '';
  return `${startYear} - ${endYear} г`;
};
</script>

<template>
  <div :class="['experience-block', { _mobile: isMobile }]">
    <ul v-if="educations.length" class="experience-block__list">
      <li
        v-for="education in educations"
        :key="education.id"
        class="experience-block__item"
      >
        <div class="experience-block__item-title">{{ education.title }}</div>
        <div class="experience-block__item-period">
          {{ getPeriod(education.date_start, education.date_end) }}
        </div>
      </li>
    </ul>
    <div v-else class="experience-block__empty">
      Автор профиля пока не указал информацию об образовании
    </div>
  </div>
</template>

<style lang="less">
.experience-block {
  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: @size-x5 0;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
    }

    &:not(:last-child) {
      border-bottom: 1px solid @color-gallery;
    }
  }

  &__item-title {
    font-size: @size-x4;
    line-height: 22px;
    font-weight: 700;
    max-width: 416px;
  }

  &__item-period {
    font-weight: 400;
    font-size: @size-x4;
    line-height: 22px;
    color: @color-dove-gray;
    white-space: nowrap;
  }

  &__empty {
    font-weight: 500;
  }

  &._mobile &__item {
    padding: @size-x4 0;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
    }
  }

  &._mobile &__item-title,
  &._mobile &__item-period {
    font-size: 14px;
    line-height: 19px;
  }

  &._mobile &__item-title {
    max-width: 208px;
  }
}
</style>
